/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { OasOperation } from '../../openapi/models/OasOperation';
import { OasResponse } from '../../openapi/models/OasResponse';
import { MarshallCompat } from '../../compat/MarshallCompat';
import { Node } from '../../core/models/Node';
import { OasResponses } from '../../openapi/models/OasResponses';

/**
 * A command used to create a new response in an operation.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class NewResponseCommand extends AbstractCommand {
    public _operationPath : NodePath;

    public _statusCode : string;

    public _created : boolean;

    public _nullResponses : boolean;

    public sourceResponse : any;

    public constructor(operation? : any, statusCode? : any, sourceResponse? : any) {
        if(((operation != null && operation instanceof <any>OasOperation) || operation === null) && ((typeof statusCode === 'string') || statusCode === null) && ((sourceResponse != null && sourceResponse instanceof <any>OasResponse) || sourceResponse === null)) {
            let __args = arguments;
            super();
            if(this._operationPath===undefined) this._operationPath = null;
            if(this._statusCode===undefined) this._statusCode = null;
            if(this._created===undefined) this._created = false;
            if(this._nullResponses===undefined) this._nullResponses = false;
            if(this.sourceResponse===undefined) this.sourceResponse = null;
            if(this._operationPath===undefined) this._operationPath = null;
            if(this._statusCode===undefined) this._statusCode = null;
            if(this._created===undefined) this._created = false;
            if(this._nullResponses===undefined) this._nullResponses = false;
            if(this.sourceResponse===undefined) this.sourceResponse = null;
            (() => {
                this._operationPath = Library.createNodePath(operation);
                this._statusCode = statusCode;
                if(ModelUtils.isDefined(sourceResponse)) {
                    this.sourceResponse = Library.writeNode(sourceResponse);
                }
            })();
        } else if(operation === undefined && statusCode === undefined && sourceResponse === undefined) {
            let __args = arguments;
            super();
            if(this._operationPath===undefined) this._operationPath = null;
            if(this._statusCode===undefined) this._statusCode = null;
            if(this._created===undefined) this._created = false;
            if(this._nullResponses===undefined) this._nullResponses = false;
            if(this.sourceResponse===undefined) this.sourceResponse = null;
            if(this._operationPath===undefined) this._operationPath = null;
            if(this._statusCode===undefined) this._statusCode = null;
            if(this._created===undefined) this._created = false;
            if(this._nullResponses===undefined) this._nullResponses = false;
            if(this.sourceResponse===undefined) this.sourceResponse = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[NewResponseCommand] Executing.  Status Code=%s", this._statusCode);
        this._created = false;
        this._nullResponses = false;
        let operation : OasOperation = <OasOperation>this._operationPath.resolve(document);
        if(this.isNullOrUndefined(operation)) {
            return;
        }
        if(this.isNullOrUndefined(operation.responses)) {
            operation.responses = operation.createResponses();
            this._nullResponses = true;
        }
        let response : OasResponse = <OasResponse>operation.responses.getResponse(this._statusCode);
        if(this.isNullOrUndefined(response)) {
            response = <OasResponse>operation.responses.createResponse(this._statusCode);
            if(ModelUtils.isDefined(this.sourceResponse)) {
                Library.readNode(this.sourceResponse, response);
            }
            operation.responses.addResponse(this._statusCode, response);
            this._created = true;
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[NewResponseCommand] Reverting.");
        let operation : OasOperation = <OasOperation>this._operationPath.resolve(document);
        if(this.isNullOrUndefined(operation)) {
            return;
        }
        if(this._nullResponses) {
            operation.responses = null;
            return;
        }
        if(!this._created) {
            return;
        }
        operation.responses.removeResponse(this._statusCode);
    }
}
NewResponseCommand["__class"] = "io.apicurio.datamodels.cmd.commands.NewResponseCommand";
NewResponseCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




